import React from "react";
import { PlusCircleOutlined, MinusCircleOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { GiCheckMark } from "react-icons/gi";
import { useNavigate } from "react-router-dom";
import mtn from "../../assets/images/mtnyellow.png";
import medpharma from "../../assets/images/md_logo.png";
import Loader from "../cards/loader";
import { packageDetails, useAppStore } from "../../store";
import images from "../../assets/images/poweredbymtn.png";

export default function SelectPlan(props: any) {
  const { packages, loading } = props;
  const { setPlan } = useAppStore();
  const navigate = useNavigate();
  const [expandedIndex, setExpandedIndex] = React.useState<number | null>(null);

  async function onBuy(planx: packageDetails) {
    setPlan(planx);
    navigate(`/plan/billing/${planx.offercode}`);
  }

  return (
    <div className="h-full w-full">
      <div className="mt-4 mb-8 flex justify-center w-full px-4">
        <h1 className="text-2xl font-bold">
          Choose a <span className="text-[#1A94EC]">Plan</span> that works for
          you
        </h1>
      </div>

      {loading ? (
        <div className="border border-gray-200 rounded-xl flex justify-center items-center h-64">
          <Loader num={1} />
        </div>
      ) : !loading && packages && packages.length > 0 ? (
        <div className="space-y-4">
          {/* Plan 1 */}
          <div className="border border-gray-200 rounded-2xl overflow-hidden bg-white shadow-sm hover:shadow-md transition-shadow">
            <div className="p-5">
              <div
                className="flex justify-between items-center mb-3 cursor-pointer"
                onClick={() => setExpandedIndex(expandedIndex === 1 ? null : 1)}
              >
                <div>
                  <h3 className="text-xl font-bold text-gray-900">
                    {packages[1].description}
                  </h3>
                  <p className="text-2xl font-bold text-[#1A94EC] mt-1">
                    GH¢{packages[1].price}
                    <span className="text-base font-normal text-gray-600">/month</span>
                  </p>
                </div>
                {expandedIndex === 1 ? (
                  <MinusCircleOutlined className="text-2xl text-gray-400" />
                ) : (
                  <PlusCircleOutlined className="text-2xl text-gray-400" />
                )}
              </div>
              <p className="text-sm text-gray-600 mb-4">
                {packages[1].offers.map((v: any, idx: any) => (
                  <span key={idx}>
                    {v.name}
                    {v.name === "Telemedicine" ? <span className="mx-1">+</span> : null}
                  </span>
                ))}
              </p>
              {expandedIndex === 1 && (
                <div className="pt-4 space-y-4 border-t border-gray-100">
                  {packages[1].offers.map((itx: any, idx: any) => (
                    <div key={idx} className="pt-4">
                      <h4 className="font-semibold text-gray-900 mb-2">{itx.name}</h4>
                      <ul className="space-y-2">
                        {itx.list.map((i: any, idxx: any) => (
                          <li key={idxx} className="flex items-start">
                            <GiCheckMark
                              size={18}
                              className="text-[#1A94EC] mr-2 mt-0.5 flex-shrink-0"
                            />
                            <span className="text-gray-700">{i}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                  <Button
                    onClick={() => onBuy(packages[1])}
                    size="large"
                    className="bg-gradient-to-r from-[#1A94EC] to-[#0d7bc4] w-full h-12 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl hover:from-[#0d7bc4] hover:to-[#1A94EC] transition-all mt-4"
                  >
                    Buy now
                  </Button>
                </div>
              )}
            </div>
          </div>

          {/* Plan 2 */}
          <div className="border border-gray-200 rounded-2xl overflow-hidden bg-white shadow-sm hover:shadow-md transition-shadow">
            <div className="p-5">
              <div
                className="flex justify-between items-center mb-3 cursor-pointer"
                onClick={() => setExpandedIndex(expandedIndex === 0 ? null : 0)}
              >
                <div>
                  <h3 className="text-xl font-bold text-gray-900">
                    {packages[0].description}
                  </h3>
                  <p className="text-2xl font-bold text-[#1A94EC] mt-1">
                    GH¢{packages[0].price}
                    <span className="text-base font-normal text-gray-600">/month</span>
                  </p>
                </div>
                {expandedIndex === 0 ? (
                  <MinusCircleOutlined className="text-2xl text-gray-400" />
                ) : (
                  <PlusCircleOutlined className="text-2xl text-gray-400" />
                )}
              </div>
              <p className="text-sm text-gray-600 mb-4">
                Telemedicine + Health Insurance
              </p>
              {expandedIndex === 0 && (
                <div className="pt-4 space-y-4 border-t border-gray-100">
                  {packages[0].offers.map((itx: any, idx: any) => (
                    <div key={idx} className="pt-4">
                      <h4 className="font-semibold text-gray-900 mb-2">{itx.name}</h4>
                      <ul className="space-y-2">
                        {itx.list.map((i: any, idxx: any) => (
                          <li key={idxx} className="flex items-start">
                            <GiCheckMark
                              size={18}
                              className="text-[#1A94EC] mr-2 mt-0.5 flex-shrink-0"
                            />
                            <span className="text-gray-700">{i}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                  <Button
                    onClick={() => onBuy(packages[0])}
                    size="large"
                    className="bg-gradient-to-r from-[#1A94EC] to-[#0d7bc4] w-full h-12 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl hover:from-[#0d7bc4] hover:to-[#1A94EC] transition-all mt-4"
                  >
                    Buy now
                  </Button>
                </div>
              )}
            </div>
          </div>

          <div className="w-full flex justify-center items-center relative z-50 bottom-0">
            <img src={mtn} alt="mtn" className="h-7" />
            <img src={medpharma} alt="medpharma" className="h-7 mx-7" />
            <img src={images} alt="care" className="md:h-10 h-10 " />
          </div>
        </div>
      ) : (
        <div className="border border-solid border-gray-200 flex justify-center items-center h-full">
          <Loader num={1} />
        </div>
      )}
    </div>
  );
}
